module.exports = __webpack_public_path__ + "static/media/demo1.870fb629.png";